"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumb = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const shared_styles_1 = require("@/stylesheets/shared.styles");
require("@/components/common/dot/semantics/current-indicator");
require("@/components/common/text/text");
/**
 * 현재 위치를 계층 구조로 보여주는 내비게이션.
 * items로 링크/현재 페이지·구분자를 렌더한다.
 * 마지막 항목은 현재 페이지(aria-current="page")로 처리한다.
 */
let Breadcrumb = class Breadcrumb extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
        this.ariaLabel = 'breadcrumb';
        this.divider = '/';
    }
    render() {
        return (0, lit_1.html) `
      <nav class="breadcrumb" aria-label=${this.ariaLabel}>${this.renderItems()}</nav>
    `;
    }
    renderItems() {
        return this.items.map((item, index) => this.renderListItem(item, index));
    }
    renderListItem(item, index) {
        const isLast = index === this.items.length - 1;
        return [
            this.renderItem(item, isLast),
            this.renderCurrentIndicator(isLast),
            this.renderDivider(isLast),
        ];
    }
    renderItem(item, isLast) {
        if (item.href && !isLast) {
            return (0, lit_1.html) `
        <a class="breadcrumb-item" href=${item.href}>${item.label}</a>
      `;
        }
        return (0, lit_1.html) `
      <mm-text class="breadcrumb-item" aria-current=${(0, if_defined_js_1.ifDefined)(isLast ? 'page' : undefined)}>
        ${item.label}
      </mm-text>
    `;
    }
    renderCurrentIndicator(isLast) {
        if (!isLast)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-current-indicator></mm-current-indicator>
    `;
    }
    renderDivider(isLast) {
        if (isLast)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <i class="breadcrumb-divider" aria-hidden="true">${this.divider}</i>
    `;
    }
};
Breadcrumb.styles = [
    shared_styles_1.resetStyles,
    (0, lit_1.css) `
      :host {
        display: block;

        --breadcrumb-item-text-color: var(--primary-color);
        --breadcrumb-item-text-color-current: var(--foreground-color);
        --breadcrumb-divider-text-color: var(--border-color);
        --breadcrumb-divider-space: var(--space-3);
      }

      .breadcrumb {
        display: flex;
        align-items: center;
        width: 100%;
        /* 가로만 잘라 긴 경로를 truncate하고, focus 링이 위아래로 잘리지 않게 세로는 연다. */
        overflow-x: clip;
        overflow-y: visible;
      }

      .breadcrumb-divider {
        margin: 0 var(--breadcrumb-divider-space);
        color: var(--breadcrumb-divider-text-color);
      }

      .breadcrumb-item {
        border-radius: var(--radius);
        color: var(--breadcrumb-item-text-color);
        white-space: nowrap;

        &[aria-current='page'] {
          color: var(--breadcrumb-item-text-color-current);
        }

        &:focus-visible {
          ${shared_styles_1.focusRingStyles};
        }
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], Breadcrumb.prototype, "items", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'aria-label' })
], Breadcrumb.prototype, "ariaLabel", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Breadcrumb.prototype, "divider", void 0);
Breadcrumb = __decorate([
    (0, decorators_js_1.customElement)('mm-breadcrumb')
], Breadcrumb);
exports.Breadcrumb = Breadcrumb;
//# sourceMappingURL=data:application/json;base64,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